import {
    Navigate,
    Outlet,
  } from 'react-router';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

const ProtectedRoute = () => {
    const { isUserLoggedIn } = useAuth();
    const isAuthenticated = useIsAuthenticated();
    const { instance } = useMsal();
    const location = useLocation();

    const hasAccount = instance.getAllAccounts().length > 0;
    const isMsalAuthenticated = isAuthenticated || hasAccount;


    if(process.env.REACT_APP_SSO_ENABLED === "false"){
      return <Outlet />;
    }
    if (isUserLoggedIn && isMsalAuthenticated) {
      return <Outlet />;
    }
    else if (isMsalAuthenticated && !isUserLoggedIn) {
      return <Navigate to="/" state={{message:location.pathname}} />;
    }
    else {
      return <Navigate to="/login" replace />;
    }

};

export default ProtectedRoute;
